import {ButtonGroup, LabeledButtonGroup} from '@sollapay/ui/components';

import type {ButtonGroupItemDef} from '@sollapay/ui/components';
import type {FC, ReactNode} from 'react';

export interface PartyTypeToggleProps {
  value: string;
  onChange: (value: string) => void;
  items: ButtonGroupItemDef[];
  /** Renders via `LabeledButtonGroup` when set; omit when the caller renders its own label. */
  label?: ReactNode;
  required?: boolean;
  labelSuffix?: ReactNode;
  cornerBadge?: ReactNode;
  error?: ReactNode;
  className?: string;
}

export const PartyTypeToggle: FC<PartyTypeToggleProps> = ({
  value,
  onChange,
  items,
  label,
  required,
  labelSuffix,
  cornerBadge,
  error,
  className
}) => {
  if (label) {
    return (
      <LabeledButtonGroup
        label={label}
        required={required}
        labelSuffix={labelSuffix}
        cornerBadge={cornerBadge}
        error={error}
        className={className}
        value={value}
        onChange={onChange}
        items={items}
      />
    );
  }

  return (
    <ButtonGroup
      className={className}
      hasError={!!error}
      value={value}
      onChange={onChange}
      items={items}
    />
  );
};
